function n(n){return[n("x"),n("y")]}export{n as eachAxis};
